import { ref, computed } from 'vue';
import { 
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../services/firebase';

export default function useFirebaseAuth() {
  const user = ref(null);
  const loading = ref(true);
  const error = ref(null);

  // Setup auth state listener
  onAuthStateChanged(auth, (firebaseUser) => {
    loading.value = false;
    user.value = firebaseUser;
  });

  // Check if user is logged in
  const isLoggedIn = computed(() => user.value !== null);

  // Get current user data
  const getCurrentUser = () => {
    return user.value;
  };

  // Logout user
  const logout = async () => {
    loading.value = true;
    error.value = null;
    
    try {
      await signOut(auth);
      user.value = null;
    } catch (err) {
      error.value = err.message;
      throw err;
    } finally {
      loading.value = false;
    }
  };



  return {
    user,
    loading,
    error,
    isLoggedIn,
    getCurrentUser,
    logout
  };
} 